import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import {
  EnvironmentConfiguration, environments
} from './app/environment/services/environment.configuration';
const environment = new EnvironmentConfiguration(environments); 
if (environment.production) {
  enableProdMode();
}

const sNew = document.createElement('script');
sNew.type = 'text/javascript';
sNew.async = true; // Loads asynchronously
sNew.defer = true;

const nexusHost = environment.FEATURE_FLAGS?.NEXUS_TOYOTA_DOMAIN
  ? 'https://nexus.toyota.com'
  : 'https://nexus.ensighten.com';

if (environment.production) {
  sNew.src = `${nexusHost}/toyotanational/mstconsole-prod/Bootstrap.js`;
} else {
  sNew.src = `${nexusHost}/toyotanational/mstconsole-stage/Bootstrap.js`;
}

const s0 = document.getElementsByTagName('script')[0];
s0.parentNode.insertBefore(sNew, s0);


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
